import {
  TNormalizedUnit,
  TUnitDataDictionaryEntry,
  TUnitRegistration,
} from 'src/types/normalizedResponseTypes';
import { request } from './request';
import { PaginationMeta } from './types';
import { UNIT_STATUSES } from 'boot/constants';
import { appendPagination, PaginationParams } from './utils';
// shared

// units
export type UnitFilters = {
  regionId?: number | null;
  organisationId?: number | null;
  groupId?: number | null;
  search?: string;
};

export type UnitsParams = PaginationParams & UnitFilters;

const filterKeys: Record<keyof UnitFilters, string> = {
  regionId: 'region',
  organisationId: 'organisation',
  groupId: 'group',
  search: 'search',
};

export const fetchUnits = (params: UnitsParams = {}) => {
  const query = new URLSearchParams();
  appendPagination(query, params);

  for (const [key, apiKey] of Object.entries(filterKeys)) {
    const value = params[key as keyof UnitFilters];
    if (value != null && value !== '') {
      query.append(`filter[${apiKey}]`, String(value));
    }
  }

  return request<{ data: TNormalizedUnit[]; meta: PaginationMeta }>({
    url: `/api/v1/units?${query}`,
    method: 'GET',
  });
};

export const fetchUnit = (unitId: number) =>
  request<TNormalizedUnit>({
    url: `/api/v1/units/${unitId}`,
    method: 'GET',
  });

export const fetchDataDictionary = () =>
  request<{ data: TUnitDataDictionaryEntry[] }>({
    url: '/api/v1/units/data-dictionary',
    method: 'GET',
  });

export type RegistrationUnitFilters = {
  name?: string;
  statusIds?: number[];
};

export const fetchRegistrationUnits = ({
  name,
  statusIds,
}: RegistrationUnitFilters = {}) => {
  const query = new URLSearchParams();
  if (statusIds?.length) {
    query.append('filter[unit_status_id]', statusIds.join(','));
  }
  if (name) {
    query.append('filter[unit_name]', name);
  }

  return request<{ data: TUnitRegistration[] }>({
    url: `/api/v1/registration-units?${query}`,
    method: 'GET',
  });
};
